import firebase from "@/firebase";

const state = {
  appLoading: true,
  user: null,
  userDetails: {},
  profileUpdated: false,
  schools: []
};

const getters = {
  isAppLoading: state => state.appLoading,
  isLoggedIn: state => !state.user,
  isprofileUpdated: state => state.profileUpdated,
  getUserDetails: state => state.userDetails,
  getAccountStatus: state => !state.userDetails.premium,
  searchListed: state => state.userDetails.searchListed,
  getSchools: state => state.schools
};

const mutations = {
  appLoading: (state, payload) => (state.appLoading = payload),
  setSchools: (state, payload) => (state.schools = payload),
  setUser: state => (state.user = firebase.auth().currentUser.uid),
  updateProfile: (state, payload) => {
    state.userDetails = payload;
    state.profileUpdated = true;
  },
  localAuth: state => (state.user = "12312ad"),
  logout: state => {
    state.appLoading = true;
    state.user = null;
    state.userDetails = {};
    state.profileUpdated = false;
  },
  addExerciseId: (state, payload) =>
    state.userDetails.exerciseCompletedIds.push(payload),
  updatePostExercise: (state, { ans, ques, points }) => {
    state.userDetails.correctAnswers = state.userDetails.correctAnswers + ans;
    state.userDetails.submittedQuestions =
      state.userDetails.submittedQuestions + ques;
    state.userDetails.points = state.userDetails.points + points;
    state.userDetails.exerciseCompleted =
      state.userDetails.exerciseCompleted + 1;
  },
  sanitizeUpdateProfile: state => {
    state.userDetails.correctAnswers = 0;
    state.userDetails.submittedQuestions = 0;
    state.userDetails.points = 0;
  }
};

const actions = {
  signOut: () => {
    firebase.auth().signOut();
  },
  signIn: async ({ commit }, payload) => {
    try {
      await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password);
      return { success: true };
    } catch (err) {
      let errorMsg = "";
      switch (err.code) {
        case "auth/invalid-email":
          errorMsg = "Email not valid";
          break;
        case "auth/user-disabled":
          errorMsg = "Account blocked, kindly contact support";
          break;
        case "auth/user-not-found":
          errorMsg = "Email not found";
          break;
        case "auth/wrong-password":
          errorMsg = "Password incorrect";
      }
      return { errorMsg, success: false };
    }
  },
  signUp: async ({ commit }, payload) => {
    try {
      await firebase
        .auth()
        .createUserWithEmailAndPassword(payload.email, payload.password);
      return { success: true };
    } catch (err) {
      let errorMsg = "";
      switch (err.code) {
        case "auth/email-already-in-use":
          errorMsg = "Email Already in use";
          break;
        case "auth/invalid-email":
          errorMsg = "Invalid Email";
          break;
        case "auth/weak-password":
          errorMsg = "Weak Password";
          break;
      }
      return { errorMsg, success: false };
    }
  },
  fetchUserDetails: async ({ commit }) => {
    // fetch user details
    commit("appLoading", true);
    const userDetails = await firebase
      .firestore()
      .collection("users")
      .doc(firebase.auth().currentUser.uid)
      .get();
    if (userDetails.exists) {
      commit("updateProfile", userDetails.data());
    }

    const schools = await firebase
      .firestore()
      .collection("global")
      .doc("schools")
      .get();

    const schoolArr = [];
    const schoolsData = schools.data();
    for (let school in schoolsData) {
      schoolArr.unshift({
        schoolName: school,
        imgUrl: schoolsData[school].imgUrl,
        url: schoolsData[school].url
      });
    }
    commit("setSchools", schoolArr);
    commit("appLoading", false);
    // check if present or no
  },
  saveProfileInformation: async ({ commit }, payload) => {
    try {
      const saveProfile = await firebase
        .functions()
        .httpsCallable("saveProfileInformation")(payload);
      if (saveProfile) {
        commit("updateProfile", { ...payload, exerciseCompletedIds: [] });
      }
      return saveProfile;
    } catch (err) {
      return err;
    }
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};
